interface LeaguePlayerCardStatsProps {
	title: string;
	GW: string;
	GL: string;
	WPercentage: string;
	PW: string;
	AvgOpponentRating: string;
	AvgPartnerRating: string;
}

export const LeaguePlayerCardStats = ({ title, GW, GL, WPercentage, PW, AvgOpponentRating, AvgPartnerRating }: LeaguePlayerCardStatsProps) => {
	return (
		<div>
			<span className="text-sm font-semibold leading-5 text-brand-700">{title}</span>
			<div className="flex flex-col gap-1 rounded bg-brand-50 p-1">
				<div className="flex w-full justify-between gap-3 text-xs">
					<div className="flex flex-col items-center">
						<span className="text-gray-600">GW</span>
						<span className="font-bold text-gray-900">{GW}</span>
					</div>
					<div className="flex flex-col items-center">
						<span className="text-gray-600">GL</span>
						<span className="font-bold text-gray-900">{GL}</span>
					</div>
					<div className="flex flex-col items-center">
						<span className="text-gray-600">W%</span>

						<span className="font-bold text-gray-900">{WPercentage}</span>
					</div>
					<div className="flex flex-col items-center">
						<span className="text-gray-600">PW</span>
						<span className="font-bold text-gray-900">{PW}</span>
					</div>
					<div className="flex flex-col items-center">
						<span className="text-gray-600">PW</span>
						<span className="font-bold text-gray-900">{PW}</span>
					</div>
					<div className="flex flex-col items-center">
						<span className="text-gray-600">W%</span>
						<span className="font-bold text-gray-900">{WPercentage}</span>
					</div>
				</div>
				<div className="flex justify-between gap-8 text-xs">
					<div className="flex flex-col flex-wrap items-center">
						<span className="text-center text-gray-600">Avg opponent rating</span>
						<span className="text-center font-bold text-gray-900">{AvgOpponentRating}</span>
					</div>
					<div className="w-px bg-gray-light" />
					<div className="flex flex-col flex-wrap items-center">
						<span className="text-center text-gray-600">Avg partner rating</span>
						<span className="text-center font-bold text-gray-900">{AvgPartnerRating}</span>
					</div>
				</div>
			</div>
		</div>
	);
};
